(function () {
  const PUBLIC_API_KEY = 'JzWdBk';
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const DEFAULT_LIST_ID = 'UKQFJc';
  const PRODUCT_PAGE_SIZE = 250;
  let euNotifyProductsPromise;

  function productTags(product) {
    if (Array.isArray(product.tags)) return product.tags;

    return String(product.tags || '')
      .split(',')
      .map(function (tag) {
        return tag.trim();
      });
  }

  function isEuNotifyProduct(product) {
    return productTags(product).some(function (tag) {
      const normalizedTag = tag.trim().toLowerCase();
      return normalizedTag.indexOf('eu-phase') === 0 || normalizedTag === 'eu-product';
    });
  }

  async function fetchEuNotifyProducts(productsUrl) {
    const products = [];
    const seenProductIds = new Set();
    let page = 1;

    while (true) {
      const url = new URL(productsUrl, window.location.origin);
      url.searchParams.set('limit', String(PRODUCT_PAGE_SIZE));
      url.searchParams.set('page', String(page));

      const response = await fetch(url.toString(), {
        headers: { accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Product catalog request failed (${response.status})`);
      }

      const body = await response.json();
      const pageProducts = Array.isArray(body.products) ? body.products : [];
      let newProductCount = 0;

      pageProducts.forEach(function (product) {
        const productId = String(product.id || '');

        if (!productId || seenProductIds.has(productId)) return;

        seenProductIds.add(productId);
        newProductCount += 1;
        if (isEuNotifyProduct(product)) products.push(product);
      });

      if (pageProducts.length < PRODUCT_PAGE_SIZE || newProductCount === 0) break;
      page += 1;
    }

    return products.sort(function (firstProduct, secondProduct) {
      return String(firstProduct.title || '').localeCompare(String(secondProduct.title || ''));
    });
  }

  function productImageUrl(product) {
    const image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : null);

    if (!image) return '';
    return typeof image === 'string' ? image : image.src || '';
  }

  function productUrl(product) {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root || '/' : '/';
    return `${window.location.origin}${root}products/${encodeURIComponent(product.handle || '')}`;
  }

  function createProductOption(product) {
    const label = document.createElement('label');
    const checkbox = document.createElement('input');
    const imageWrap = document.createElement('span');
    const title = document.createElement('span');
    const imageUrl = productImageUrl(product);

    label.className = 'notify-me-product-picker__option';

    checkbox.className = 'notify-me-product-picker__checkbox';
    checkbox.type = 'checkbox';
    checkbox.name = 'product_ids[]';
    checkbox.value = String(product.id);
    checkbox.dataset.productTitle = product.title || '';
    checkbox.dataset.productHandle = product.handle || '';
    checkbox.dataset.productUrl = productUrl(product);

    imageWrap.className = 'notify-me-product-picker__image';
    imageWrap.setAttribute('aria-hidden', 'true');

    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 56;
      image.height = 56;
      imageWrap.appendChild(image);
    }

    title.className = 'notify-me-product-picker__title';
    title.textContent = product.title || '';

    label.appendChild(checkbox);
    label.appendChild(imageWrap);
    label.appendChild(title);

    return label;
  }

  function applyProductPreselection(form) {
    const productId = String(form.dataset.preselectedProductId || '');
    const matchingCheckbox = Array.from(form.querySelectorAll('input[name="product_ids[]"]')).find(
      function (checkbox) {
        return checkbox.value === productId;
      }
    );

    if (matchingCheckbox) matchingCheckbox.checked = true;
  }

  async function loadProductPicker(form) {
    const picker = form.querySelector('[data-product-picker]');
    const options = form.querySelector('[data-picker-options]');
    const status = form.querySelector('[data-picker-status]');
    const submitButton = form.querySelector('[type="submit"]');

    if (!picker || !options || form.dataset.pickerReady === 'true') {
      applyProductPreselection(form);
      return;
    }

    picker.setAttribute('aria-busy', 'true');
    if (status) {
      status.hidden = false;
      status.textContent = form.dataset.productsLoading || '';
    }

    try {
      if (!euNotifyProductsPromise) {
        euNotifyProductsPromise = fetchEuNotifyProducts(form.dataset.productsUrl || '/products.json');
      }

      const products = await euNotifyProductsPromise;
      const fragment = document.createDocumentFragment();

      products.forEach(function (product) {
        fragment.appendChild(createProductOption(product));
      });

      options.replaceChildren(fragment);
      options.hidden = products.length === 0;
      form.dataset.pickerReady = 'true';

      if (status) {
        status.hidden = products.length > 0;
        status.textContent = products.length > 0 ? '' : form.dataset.productsEmpty || '';
      }

      if (submitButton) submitButton.disabled = products.length === 0;
      applyProductPreselection(form);
    } catch (error) {
      console.error('EU phase product picker failed:', error);
      euNotifyProductsPromise = null;

      if (status) {
        status.hidden = false;
        status.textContent = form.dataset.productsError || '';
      }
    } finally {
      picker.setAttribute('aria-busy', 'false');
    }
  }

  function prepareNotifyForm(form, productId) {
    const fields = form.querySelector('.notify-me-form__fields');
    const successMessage = form.querySelector('.notify-me-form__message--success');
    const errorMessage = form.querySelector('.notify-me-form__message--error');
    const selectionError = form.querySelector('[data-selection-error]');

    form.reset();
    form.dataset.preselectedProductId = String(productId || '');
    if (fields) fields.hidden = false;
    if (successMessage) successMessage.hidden = true;
    if (errorMessage) errorMessage.hidden = true;
    if (selectionError) selectionError.hidden = true;

    loadProductPicker(form);
  }

  document.addEventListener(
    'click',
    function (event) {
      const openerButton =
        event.target instanceof Element ? event.target.closest('[data-notify-product-id]') : null;

      if (!openerButton) return;

      const opener = openerButton.closest('modal-opener');
      const modalSelector = opener && opener.dataset.modal ? opener.dataset.modal : '#NotifyMePicker';
      const modal = document.querySelector(modalSelector);
      const form = modal ? modal.querySelector('.notify-me-form') : null;

      if (form) prepareNotifyForm(form, openerButton.dataset.notifyProductId);
    },
    true
  );

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.matches('.notify-me-form')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const emailInput = form.elements.email;
      const email = String(emailInput && emailInput.value ? emailInput.value : '')
        .trim()
        .toLowerCase();
      const listId = String(form.dataset.klaviyoListId || DEFAULT_LIST_ID).trim();
      const selectedProducts = Array.from(
        form.querySelectorAll('input[name="product_ids[]"]:checked')
      ).map(function (checkbox) {
        return {
          id: checkbox.value,
          title: checkbox.dataset.productTitle || '',
          handle: checkbox.dataset.productHandle || '',
          url: checkbox.dataset.productUrl || ''
        };
      });
      const submitButton = form.querySelector('[type="submit"]');
      const fields = form.querySelector('.notify-me-form__fields');
      const successMessage = form.querySelector('.notify-me-form__message--success');
      const errorMessage = form.querySelector('.notify-me-form__message--error');
      const selectionError = form.querySelector('[data-selection-error]');

      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
      if (selectionError) selectionError.hidden = true;

      if (!email || !listId || !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (selectedProducts.length === 0) {
        if (selectionError) selectionError.hidden = false;

        const firstProduct = form.querySelector('input[name="product_ids[]"]');
        if (firstProduct) firstProduct.focus();
        return;
      }

      const productIds = selectedProducts.map(function (product) {
        return product.id;
      });
      const productTitles = selectedProducts.map(function (product) {
        return product.title;
      });
      const productHandles = selectedProducts.map(function (product) {
        return product.handle;
      });
      const productUrls = selectedProducts.map(function (product) {
        return product.url;
      });

      const originalLabel = submitButton.dataset.defaultLabel || submitButton.textContent.trim();
      const waitingLabel = submitButton.dataset.waitLabel || originalLabel;

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = waitingLabel;

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'EU phase product picker',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  },
                  properties: {
                    'Notify me product IDs': productIds,
                    'Notify me products': productTitles,
                    'Notify me product handles': productHandles,
                    'Notify me product URLs': productUrls,
                    'Notify me market': form.dataset.market || '',
                    'Notify me locale': form.dataset.locale || ''
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(PUBLIC_API_KEY)}`, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload)
        });

        if (response.status !== 202) {
          const responseText = await response.text();
          throw new Error(`Klaviyo rejected the subscription (${response.status}): ${responseText}`);
        }

        form.reset();
        if (fields) fields.hidden = true;
        if (successMessage) {
          successMessage.hidden = false;
          successMessage.focus();
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lead_form_submit',
          form_name: 'product_notify_me',
          form_location: 'product_picker',
          product_ids: productIds,
          product_handles: productHandles
        });
      } catch (error) {
        console.error('Klaviyo notify-me subscription failed:', error);

        if (errorMessage) {
          errorMessage.hidden = false;
          errorMessage.focus();
        }
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.textContent = originalLabel;
      }
    },
    true
  );
})();
